module.exports = __webpack_public_path__ + "img/hzzy.c9a8a4c8.png";